import { api as wiredApi } from './index';

/**
 * "Forgot password?" on InGo's API, for a client or a rider (armkit/accounts
 * 0.3.4, ingo-e0): asking for a link to one's own address, signed out, and the
 * page the link opens. The old screens mailed a six-digit code through a
 * Supabase edge function and set the password from the browser.
 *
 * The server answers the request the same whether or not the address is
 * anyone's, so the screen says what the server says and nothing more.
 *
 * `prefix` is the realm's: `/customer` or `/rider`. Built from its client so a
 * test can hand it a fake; `clientResets` and `riderResets` are the wired copies.
 */
export function createPasswordResets({ api, prefix }) {
  const link = (token) => `${prefix}/password-resets/${encodeURIComponent(token)}`;

  return {
    /** `POST {prefix}/password-resets`: the server's sentence, the same for every address. */
    async ask(email) {
      const { message } = await api.post(`${prefix}/password-resets`, { email: String(email).trim() });

      return message;
    },

    /** Whose account the link opens (first name and address) and until when; refused once dead. */
    async read(token) {
      const { data } = await api.get(link(token));

      return data;
    },

    /** Sets their own password with the link; every other session is signed out. Never signs in. */
    async choose(token, password, passwordConfirmation) {
      const { message } = await api.post(link(token), { password, password_confirmation: passwordConfirmation });

      return message;
    },
  };
}

export const clientResets = createPasswordResets({ api: wiredApi, prefix: '/customer' });
export const riderResets = createPasswordResets({ api: wiredApi, prefix: '/rider' });
